<template lang="pug">
.atalho(
    @click='irParaRota',
    :style='{ height: $i18n._vm.locale === "en" ? "100px" : "90px" }'
)
    section.atalho__imagem
        img(:src='atalho.linkIcone', alt='atalho', height='100%', width='100%')
    section.atalho__titulo
        | {{ atalho.nome }}
</template>

<script>
export default {
    name: 'Atalho',
    props: {
        atalho: {
            type: Object,
            required: true,
            default: () => {}
        },
        habilitarAcaoRota: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    methods: {
        irParaRota() {
            if (
                this.atalho.nome ===
                this.$t(
                    'mensagens.operacao.monitoramento.monitoramentoBaseDados'
                )
            ) {
                this.$emit('abrirModalAtualizacaoBases');
                return;
            }
            if (this.habilitarAcaoRota) {
                this.$router.push(this.atalho.nomeRota);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.atalho {
    width: 100px;
    min-width: 100px;
    height: fit-content;
    padding: 10px 5px;
    background: var(--white);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    cursor: pointer;

    .atalho__imagem {
        height: 30px;
        width: 100%;
    }

    .atalho__titulo {
        margin-top: 6px;
        width: 100%;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        height: auto;
        line-height: 1.3em;
        text-align: center;
        overflow: hidden;
        color: var(--primary);
        letter-spacing: -0.5px;
    }
}
</style>
